export const INIT_STATE = "INIT_STATE";
export const SEARCH = "SEARCH";
export const BRAND_FILTER = "BRAND_FILTER";
export const SONG_FILTER = "SONG_FILTER";
export const ADD_FAV = "ADD_FAV";
export const DEL_FAV = "DEL_FAV";
export const OPEN_DETAIL = "OPEN_DETAIL";
export const CLOSE_DETAIL = "CLOSE_DETAIL";